module.exports = __webpack_public_path__ + "img/phone.509bd2ee.jpg";